module.exports = __webpack_public_path__ + "static/media/what_is_v_passport.f1876a09.jpg";